// 群聊——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `groupChat/index${i + 1}`,
  name: `groupChatIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/groupChat/index${i + 1}.vue`)
}))
const Branch1Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `groupChat/branch1/index${i + 1}`,
  name: `groupChatBranch1Index${i + 1}`,
  component: () => import(`@/views/wxSettings/groupChat/branch1/index${i + 1}.vue`)
}))
const Branch2Routes = Array.from({ length: 4 }, (_, i) => ({
  path: `groupChat/branch2/index${i + 1}`,
  name: `groupChatBranch2Index${i + 1}`,
  component: () => import(`@/views/wxSettings/groupChat/branch2/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 群聊——主流程，开始
    ...MainRoutes,
    // 群聊——分支流程，开始
    ...Branch1Routes,
    // 群聊——分支流程，开始
    ...Branch2Routes,


  ],
};
